import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Wish from './wishfoods/Wish';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Wish />
    </React.StrictMode>
);

reportWebVitals();
